import { currentModuleKey } from "@/models/caseModules";
import { INTAKE_STAGE, intakeStatusLabel } from "@/models/intakeStatus";
const STEP_PAGES = {
    benefits_verification: { route: "qualify-order", status: INTAKE_STAGE.QUALIFY_PATIENT },
    clinical_review: { route: "document-review-order", status: INTAKE_STAGE.CLINICAL_REVIEW },
};
/** The step an intake order's status says is open; the backend derives that status from the step records. */
export function openStepOf(status) {
    if (status === INTAKE_STAGE.CLINICAL_REVIEW)
        return "clinical_review";
    if (status === INTAKE_STAGE.QUALIFY_PATIENT)
        return "benefits_verification";
    return null;
}
/** The page that works one step of an order: from a feed row today, from a Worklist chip next. */
export function stepRoute(step, orderId, readOnly = false) {
    return { name: STEP_PAGES[step].route, params: { id: orderId }, ...(readOnly ? { query: { ro: "1" } } : {}) };
}
export function documentRoute(documentKey, readOnly = false) {
    return { name: "intake-review", params: { id: documentKey }, query: readOnly ? { ro: "1" } : {} };
}
/** An intake step's page: the fax's review, the order's BV or MN page, or the MN page read only for a policy check. */
export function moduleStepRoute(moduleKey, links, readOnly) {
    const step = currentModuleKey(moduleKey);
    if (step === "fax_intake")
        return links.documentKey ? documentRoute(links.documentKey, readOnly) : null;
    if (step === "necessity_check") {
        return links.intakeOrderId ? stepRoute("clinical_review", links.intakeOrderId, true) : null;
    }
    if (step !== "benefits_verification" && step !== "clinical_review")
        return null;
    return links.intakeOrderId ? stepRoute(step, links.intakeOrderId, readOnly) : null;
}
export function stepLabel(step) {
    return intakeStatusLabel(STEP_PAGES[step].status);
}
